import React, { useEffect, useReducer, useRef, useState } from 'react'
import Loader from '../../../shared/Loader/Loader'
import ModalFooter from '../../Shared/ModalFooter'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import Table from '../../Shared/Table'
import GridColumnHeader from '../../Shared/GridColumnHeader'
import NotificationHandler from '../../../../utils/NotificationHandler'
import { enumUtil } from '../../../../utils/Enum'
import FormValidator from '../../../../utils/FormValidator'
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest'
import isNull from '../../../../utils/NullChecking'
import { FindFirstChild, FindSecondChild } from '../../../../utils/FindMenuOption'
import { connect } from 'react-redux'
import { saveAs } from "file-saver"
import handleCopyText from '../../../shared/CopyData'
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import Modal from 'react-bootstrap/Modal';


function InsuranceDocuments(props) {
    let InsuranceDOC_Modal = {
        InsuranceID: "",
        FILENAME: "",
        FILE: "",
        Description: "",
        Title: ""
    }
    let valModal = {}
    let ValidationModal = {
        FileName: "",
        NoOfPagesval: "",
        FileVal: '',

    }
    const [isLoading, setIsLoading] = useState(false);
    const [mainInsuranceDocument, setmainInsuranceDocument] = useState(InsuranceDOC_Modal);
    const [InsuranceDOCsaveUpdatemodal, setInsuranceDOCsaveUpdatemodal] = useState({});
    const [InsuranceDOCValidationModal, setInsuranceDOCValidationModal] = useState(ValidationModal)
    const [DocumentID, setDocumentID] = useState('0');
    const [is, setIs] = useState(false);
    const [file, setfile] = useState()
    const [InsuranceDOCData, setInsuranceDOCData] = useState([]);
    const fileInputRef = useRef(null);
    const [del, setDel] = useState(false);
    const [isClose, setIsClose] = useState();
    const { InsuranceID, Settings } = { ...props }
    const [copiedText, setCopiedText] = useState({});
    const [pdfFile, setPdfFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    //For Pagination
    const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const API_URL = enumUtil.controller.InsuranceDocument
    const API_URL_General = enumUtil.controller.General
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Document')?.IsDeleted
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    useEffect(() => {
        if (DocumentID !== null && DocumentID !== 0) {
            setDel(true)
            setDocumentID(DocumentID)
        } else {
            setDocumentID(0);
            setDel(true)
        }
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.InsuranceDocument,
            "ID": DocumentID
        }).then((response) => {
            setIs(true)
            setIsLoading(false)
            setmainInsuranceDocument(response)
        }).catch((error) => {
        })
        if (!isNull(DocumentID)) {
            setDocumentID(DocumentID)
        }
    }, []);
    useEffect(() => {
        LoadData();
        setIsLoading(true)
    }, [PerPage, PageNo, isClose]);
    const handleEdit = (DocumentID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.InsuranceDocument,
            "ID": DocumentID + ""
        }).then((response) => {
            setDocumentID(DocumentID)
            setmainInsuranceDocument(response)
            setfile(response.file)
            setIsLoading(false)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }
    const LoadData = (param) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.InsuranceDocument,
            "ID": InsuranceID + "",
            "PerPage": PerPage,
            "PageNo": PageNo,
        }).then((response) => {
            setIsLoading(false)
            setInsuranceDOCData(response?.Rows)
            handleGridHeader({ defaultData: response?.Rows })
        }).catch((error) => {
            setInsuranceDOCData([])
            setIsLoading(false)
        })
    }
    const DownloadFile = (data) => {
        // let FileName;
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": data.FilePath,
        }, "Download",).then((response) => {
            setIsLoading(false)
            let blob = new Blob([response]);
            saveAs(blob, data.FILENAME);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const ViewPdf = (data) => {
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": data.FilePath
        }, 'Download').then((response) => {
            setIsLoading(false)
            console.log(response.type);
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };

                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else {
                let file = new Blob([response]);
                const fileUrl = URL.createObjectURL(file);
                setPdfFile(fileUrl)
            }
            setModalActive(true)
            console.log('modalActive:', modalActive);

        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }
    const columns = [
        {
            key: 'FILENAME',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'File Name'} sortIcon={true} type={'string'} colKey={'FILENAME'} data={InsuranceDOCData} setData={setInsuranceDOCData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button
                        className="btn btn-link p-0">
                        <div className="validation_message" onClick={() => handleEdit(row.InsuranceDocumentID)}>{row.FILENAME} </div>
                    </button>
                );
            },
        },
        {
            key: 'Title',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Title'} sortIcon={true} type={'string'} colKey={'Title'} data={InsuranceDOCData} setData={setInsuranceDOCData} />),
            resizable: true,
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={InsuranceDOCData} setData={setInsuranceDOCData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                                <div className='copy_icon'>{row.Description}</div>
                                <div className="icon_copy">
                                    <i className='icon-Icon-ionic-ios-copy'></i>
                                    <p class="tool_tip xsm_text text-light" onClick={() => handleCopy(row.InsuranceDocumentID, row.Description)}>Copy</p>
                                </div>
                                {copiedText[`${row.InsuranceDocumentID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                            </div>
                        </div>
                    </>
                )
            }
        },
        {
            key: 'Action',
            name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
            resizable: true,
            renderCell({ row }) {
                return (
                    <>
                        <button className='border-0 no-width ms-2 Sdownload-btn' onClick={() => DownloadFile(row)}>
                            <i className="icon-download-svgrepo-com" />
                        </button>
                        <button className='border-0 bg-transparent' onClick={() => ViewPdf(row)}>
                            <i class="icon-Icon-awesome-eye"></i>
                        </button>
                        <button className={IsDeleteAllowed ? 'border-0 bg-transparent p-0' : 'border-0 bg-transparent p-0 disabled'} onClick={() => DeleteDocument(row.InsuranceDocumentID)}>
                            <i className="icon-delete"></i>
                        </button>
                    </>
                )
            }
        }
    ]

    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    const savefile = (e) => {
        const { name, files } = e.target;
        const file = files[0]; // Get the selected file

        if (!file) return; // If no file is selected, return early

        const modalCopy = { ...mainInsuranceDocument };
        const saveModalCopy = { ...InsuranceDOCsaveUpdatemodal };

        // Set the file name in both state objects
        if (name === 'FILE') {
            modalCopy['FILENAME'] = file.name;
            saveModalCopy['FILENAME'] = file.name;
        }

        setmainInsuranceDocument(modalCopy);
        setInsuranceDOCsaveUpdatemodal(saveModalCopy);

        // Define supported file types
        const supportedFileTypes = [
            'image/png',
            'image/jpeg',
            'image/jpg',
            'application/pdf',
            'application/msword',
            'text/plain',
        ];

        // Check if the file type is supported
        if (
            supportedFileTypes.includes(file.type) ||
            file.name.endsWith('.pdf') ||
            file.name.endsWith('.doc') ||
            file.name.endsWith('.tex') ||
            file.name.endsWith('.jpg') ||
            file.name.endsWith('.png')
        ) {
            const reader = new FileReader();

            reader.onloadend = (event) => {
                const value = reader.result.toString();
                modalCopy[name] = value; // Base64 encoded string

                setmainInsuranceDocument({ ...modalCopy });
                for (const property in modalCopy) {
                    if (name === property) {
                        saveModalCopy[name] = event.target.result.split("base64,")[1];
                    }
                }

                setInsuranceDOCsaveUpdatemodal({ ...saveModalCopy });
            };

            reader.readAsDataURL(file);
        }
    };

    const InsuranceDocumentValidation = async () => {
        let ValidationModal = {
            FileName: FormValidator(
                mainInsuranceDocument.FILENAME,
                enumUtil.enumValidationType.Required,
                'File Name'
            ),
            FileVal: FormValidator(
                mainInsuranceDocument?.FILE,
                enumUtil.enumValidationType.Required,
                'File',
            ),
        }
        await setInsuranceDOCValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const clearDOC = () => {
        setmainInsuranceDocument(InsuranceDOC_Modal)
        setDocumentID('0')
    }
    const handleSaveDocument = async () => {
        
        await InsuranceDocumentValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {

            let saveModal = {
                TableName: enumUtil.enumAPITableName.InsuranceDocument,
                ID: DocumentID,
                data: {
                    ...InsuranceDOCsaveUpdatemodal,
                    InsuranceID: InsuranceID,
                    savefile
                },
                value: null
            }
            ////////
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveInsuranceDocuments", 'post', saveModal).then((response) => {
                console.log("API Response:", response);
                if (!isNull(response.id)) {
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setDocumentID(response.id)
                    clearDOC()
                    LoadData()
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const DeleteDocument = (DocumentID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/DeleteSingleRecord ", 'post', {
            "ID": DocumentID,
            "TableName": enumUtil.enumAPITableName.InsuranceDocument,
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Deleted Succesfully', enumUtil.enumtoaster.success);
            setIsClose((Math.random()))
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }
    const handleInsuranceDOCchange = (e) => {
        let { name, value } = e.target;

        let modal = { ...mainInsuranceDocument }
        let saveModal = { ...InsuranceDOCsaveUpdatemodal }
        modal[name] = value
        setmainInsuranceDocument(modal)

        for (var property in InsuranceDOC_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setInsuranceDOCsaveUpdatemodal(saveModal)
    }
    const removeFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setfile(null);
        const updatedMainBillingDocumentModal = { ...mainInsuranceDocument };
        updatedMainBillingDocumentModal['FILENAME'] = '';
        setmainInsuranceDocument({...updatedMainBillingDocumentModal,FILE:''});
    };
    return (
        <div>
            <>
                <div className="row hk-docFlex__content__flex m-0 ar_upload-popup">
                    <div className="doc-table col-md-8 px-0 doc_list ar-no-doc">
                        <div className="doc-table__header pb-1 pt-0 px-0">
                            <p className="heading fs-13">Document Lists</p>
                        </div>
                        {isLoading ? <Loader /> : null}
                        <Table
                            columns={columns}
                            rows={InsuranceDOCData}
                            height='465px'
                            dynamicClass='fill-grid DataGrid-Table hk-exp-table patient_doc '
                            rowHeight={25}
                            Key={21}
                            Name={'PatientSearch'}
                            handleFingByCreteria={handleFingByCreteria}
                            PerPage={PerPage}
                            PageNo={PageNo}
                            hideColClass={'hide'}
                            isLoading={isLoading}
                            hidePagination={true}
                        />
                    </div>
                    <div className="doc-right-col col-md-4 px-0">
                        <div className="upload-box">
                            <div className="upload-box__header">
                                <p className="heading">Upload Document</p>
                                <span className="icon-box">
                                    <i className="icon-upload-converted"></i>
                                </span>
                            </div>
                            <div className="upload-box__filePicker">
                                <div className="upload-box__filePicker__fileInfo mt-1 d-flex align-items-center">
                                    <div className="upload-box__filePicker__form w-100 px-0 d-flex flex-column gap-10 h-auto">
                                        {mainInsuranceDocument.FILENAME ? (
                                            <div className="upload-box__filePicker__fileInfo mb-1 mt-0-5 py-2 d-flex align-items-center px-0">
                                                <p className='mb-0 heading text-nowrap' title={mainInsuranceDocument.FILENAME}>{mainInsuranceDocument.FILENAME}</p>
                                                <i className='icon-delete' onClick={removeFile}>
                                                </i>
                                            </div>
                                        ) : (
                                            <div className={InsuranceDOCValidationModal.FileVal ? 'form-group input error' : "form-group input mb-0"}>
                                                <div className='upload-box__filePicker__Btn m-0 mb-1'>
                                                    <input
                                                        type="file"
                                                        className="inputfile"
                                                        id="FILE"
                                                        name="FILE"
                                                        accept=".png, .txt, .pdf, .tiff"
                                                        onChange={savefile}
                                                        ref={fileInputRef}
                                                    />
                                                    <i className="icon-link"></i>
                                                    <label htmlFor="file">Upload a File<span className='req'>*</span></label>
                                                </div>
                                                {InsuranceDOCValidationModal.FileVal}
                                            </div>)


                                        }
                                        <div className=" form-group input ">
                                            <label htmlFor="FILENAME">File Name<span className='req'>*</span></label>
                                            <div className={InsuranceDOCValidationModal.FileName ? 'form-group input error' : 'form-group input mb-0'}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="FILENAME"
                                                    name="FILENAME"
                                                    value={mainInsuranceDocument.FILENAME}
                                                    disabled={mainInsuranceDocument?.FILE === '' || mainInsuranceDocument?.FILE === null}
                                                    onChange={handleInsuranceDOCchange}
                                                />
                                                {InsuranceDOCValidationModal.FileName}
                                            </div>
                                        </div>
                                        <div className='form-group input ar_palceholder mb-0'>
                                            <label htmlFor="Title">Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="Title"
                                                name="Title"
                                                value={mainInsuranceDocument.Title}
                                                onChange={handleInsuranceDOCchange}
                                            />

                                        </div>
                                        <div className="input form-group mb-0">
                                            <label htmlFor="Description">Description</label>
                                            <textarea
                                                className="form-control doc-textarea"
                                                id="Description"
                                                name="Description"
                                                value={mainInsuranceDocument.Description}
                                                onChange={handleInsuranceDOCchange}
                                                rows="4">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className='br-bottom-1 br-clr position-absolute bottom-0 w-100'>
                    <div className="btns-group text-end px-3 br-top-1 br-clr d-flex align-items-center justify-content-end gap-2">
                        <button className="btn m-0 my-1 btn-gray" onClick={clearDOC}>Cancel</button>
                        <button className={IsEditAllowed ? "btn m-0 my-1 btn-orange" : "btn m-0 my-1 btn-orange disabled"} onClick={handleSaveDocument}>Save</button>
                    </div>
                </div>
            </>
            <>
                <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                    <Modal.Body>
                        <div className="download-header">
                            <div className='hide-me'></div>
                            {/* <button className="btn download-btn">
              Download PDF
            </button> */}

                            <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
                                <i className="icon-Icon-metro-cross"></i>
                            </button>
                        </div>
                        <div className="pdfView-box">

                            {!isNull(txtFile) ? txtFile : ''}
                            {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

                        </div>
                        {isLoading ? <Loader /> : null}

                        {pdfFile &&
                            <>
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                    <Viewer fileUrl={pdfFile}
                                        defaultScale={1}
                                        plugins={[defaultLayoutPluginInstance]} />
                                </Worker>
                            </>
                        }
                    </Modal.Body>
                    <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                        <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
                    </div>
                </Modal>
            </>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(InsuranceDocuments)